'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

// For some weird reason, in Chrome, `setTimeout()` would lag up to a second (or more) behind.
// Turns out, Chrome developers have deprecated `setTimeout()` API entirely without asking anyone.
// Replacing `setTimeout()` with `requestAnimationFrame()` can work around that Chrome bug.
// https://github.com/bvaughn/react-virtualized/issues/722


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _scrollIntoViewIfNeeded = require('scroll-into-view-if-needed');

var _scrollIntoViewIfNeeded2 = _interopRequireDefault(_scrollIntoViewIfNeeded);

var _reactCreateRef = require('react-create-ref');

var _reactCreateRef2 = _interopRequireDefault(_reactCreateRef);

var _requestAnimationFrameTimeout = require('request-animation-frame-timeout');

var _Close = require('./Close');

var _Close2 = _interopRequireDefault(_Close);

var _OnFocusOutOrTapOutside = require('./OnFocusOutOrTapOutside');

var _OnFocusOutOrTapOutside2 = _interopRequireDefault(_OnFocusOutOrTapOutside);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// `PureComponent` is only available in React >= 15.3.0.
var PureComponent = _react2.default.PureComponent || _react2.default.Component;

/**
 * Usage:
 *
 * <button onClick={() => this.expandable.toggle()}>
 *   Toggle
 * </button>
 *
 * <Expandable ref={ref => this.expandable = ref}>
 *   ...
 * </Expandable>
 *
 * Methods:
 * * `.toggle()`
 * * `.expand()`
 * * `.collapse()`
 * * `.isExpanded()`
 */
var Expandable = (_temp2 = _class = function (_PureComponent) {
	_inherits(Expandable, _PureComponent);

	function Expandable() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, Expandable);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Expandable.__proto__ || Object.getPrototypeOf(Expandable)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
			// This initialization is required for `if (expand === expanded)`.
			expanded: false
		}, _this.onFocusOutRef = (0, _reactCreateRef2.default)(), _this.isExpanded = function () {
			return _this.state.expanded;
		}, _this.expand = function (parameters) {
			return _this.toggle(true, parameters);
		}, _this.collapse = function () {
			return _this.toggle(false);
		}, _this.toggle = function (expand) {
			var parameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
			var _this$props = _this.props,
			    onExpand = _this$props.onExpand,
			    onExpanded = _this$props.onExpanded,
			    onCollapse = _this$props.onCollapse,
			    onCollapsed = _this$props.onCollapsed;
			var expanded = _this.state.expanded;

			// If no `expand` argument provided then just toggle.

			var isExpandedState = expanded && _this.process !== 'unexpand' || _this.process === 'expand';
			if (expand === undefined) {
				expand = !isExpandedState;
			}

			// Don't collapse if already collapsed.
			// Don't expand if already expanded
			// unless manually forcing a refresh of content.

			var refreshingExpanded = void 0;
			if (expand && isExpandedState && parameters.refresh) {
				refreshingExpanded = true;
			}

			if (expand === isExpandedState && !refreshingExpanded) {
				return Promise.resolve();
			}

			// if (this.isToggling && !refreshingExpanded) {
			// 	return Promise.resolve()
			// }

			if (_this.cancelProcess) {
				_this.cancelProcess();
			}

			var cancelled = void 0;

			var reset = function reset() {
				_this.process = undefined;
				_this.processPhase = undefined;
				_this.cancelProcess = undefined;
			};

			var nextPhase = function nextPhase(phase) {
				if (!cancelled) {
					_this.processPhase = phase;
					return true;
				}
			};

			function endProcess() {
				nextPhase();
				reset();
			}

			var phaseCancellers = {};
			function onCancelPhase(phase, handler) {
				phaseCancellers[phase] = handler;
			}

			_this.cancelProcess = function () {
				if (phaseCancellers[_this.processPhase]) {
					phaseCancellers[_this.processPhase]();
				}
				cancelled = true;
				reset();
			};

			if (expand) {
				// Expand.
				_this.process = 'expand';
				onCancelPhase('scheduleExpand', function () {
					return (0, _requestAnimationFrameTimeout.clearTimeout)(_this.expandTimeout);
				});
				onCancelPhase('expanded', function () {
					return (0, _requestAnimationFrameTimeout.clearTimeout)(_this.scrollIntoViewTimer);
				});
				nextPhase('preload');
				return _this.preload().then(function () {
					return new Promise(function (resolve) {
						if (!nextPhase('render')) {
							return;
						}
						_this.setState({
							shouldRender: true
						},
						// Without an artificial delay for some reason the CSS "expand" animation won't play.
						// Perhaps a browser decides to optimize two subsequent renders
						// and doesn't render "pre-expanded" and "expanded" states separately.
						// Even with a 0ms delay it would randomly play/not-play the expand animation.
						function () {
							if (!nextPhase('scheduleExpand')) {
								return;
							}
							if (onExpand) {
								onExpand();
							}
							// Using `requestAnimationFrame()` instead of `setTimeout()`
							// because otherwise there would be a weird and strange delay.
							_this.expandTimeout = (0, _requestAnimationFrameTimeout.setTimeout)(function () {
								if (!nextPhase('expand')) {
									return;
								}
								_this.expandTimeout = undefined;
								_this.setState({ expanded: true }, function () {
									if (!nextPhase('expanded')) {
										return;
									}
									if (onExpanded) {
										onExpanded();
									}
									if (_this.onFocusOutRef.current) {
										_this.onFocusOutRef.current.listenToTouches();
									}
									_this.scrollIntoView().then(endProcess);
									// `resolve()` doesn't wait for `scrollIntoView`
									// because other components use it like `.toggle().then(focus)`
									// where it shouldn't wait for the final phases like "scroll into view".
									resolve();
								});
							}, 0);
						});
					});
				});
			} else {
				// Un-Expand.
				_this.process = 'unexpand';
				onCancelPhase('unexpand', function () {
					return (0, _requestAnimationFrameTimeout.clearTimeout)(_this.scrollIntoViewTimer);
				});
				onCancelPhase('unexpanded', function () {
					return (0, _requestAnimationFrameTimeout.clearTimeout)(_this.waitUnForExpandAnimationTimer);
				});
				nextPhase('unexpand');
				if (_this.onFocusOutRef.current) {
					_this.onFocusOutRef.current.stopListeningToTouches();
				}
				if (onCollapse) {
					onCollapse({ focusOut: _this.focusOut });
				}
				// Set `expanded` to `false` to play the collapse CSS animation.
				// Once that animation is finished remove
				// the contents of the `<Expanded/>` from DOM.
				return new Promise(function (resolve) {
					_this.setState({ expanded: false }, function () {
						if (!nextPhase('unexpanded')) {
							return;
						}
						if (onCollapsed) {
							onCollapsed();
						}
						var waitForUnExpandAnimation = function waitForUnExpandAnimation() {
							var expandAnimationDuration = _this.props.expandAnimationDuration;

							return new Promise(function (resolve) {
								_this.waitUnForExpandAnimationTimer = (0, _requestAnimationFrameTimeout.setTimeout)(resolve, expandAnimationDuration * 1.1);
							});
						};
						waitForUnExpandAnimation().then(function () {
							if (!nextPhase('unrender')) {
								return;
							}
							_this.setState({ shouldRender: false }, endProcess);
						});
						// `resolve()` doesn't wait for `removeFromDOMAfterCollapsed`
						// because other components use it like `.toggle().then(focus)`
						// where it shouldn't wait for the final phases like "scroll into view".
						resolve();
					});
				});
			}
		}, _this.onKeyDown = function (event) {
			if (event.defaultPrevented) {
				return;
			}

			if (event.ctrlKey || event.altKey || event.shiftKey || event.metaKey) {
				return;
			}

			switch (event.keyCode) {
				// Collapse on "Escape".
				case 27:
					event.preventDefault();
					// Collapse the list if it's expanded
					return _this.collapse();
			}
		}, _this.storeContainerNode = function (node) {
			return _this.container = node;
		}, _this.getContainerNode = function () {
			return _this.container;
		}, _this.onBlur = function (event) {
			return _this.onFocusOutRef.current && _this.onFocusOutRef.current.onBlur(event);
		}, _this.onFocusOut = function (event) {
			var onFocusOut = _this.props.onFocusOut;

			_this.focusOut = true;
			onFocusOut(event);
			_this.focusOut = undefined;
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(Expandable, [{
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			if (this.cancelProcess) {
				this.cancelProcess();
			}
		}
	}, {
		key: 'preload',


		// Preload `<Expanded/>` content (if required).
		value: function preload() {
			var _this2 = this;

			var _props = this.props,
			    preload = _props.preload,
			    onPreloadStateChange = _props.onPreloadStateChange;


			if (preload) {
				this.setState({
					isPreloading: true
				});
				if (onPreloadStateChange) {
					onPreloadStateChange(true);
				}
			}

			return (preload ? preload() : Promise.resolve()).then(function () {
				if (onPreloadStateChange) {
					onPreloadStateChange(false);
				}
				_this2.setState({
					isPreloading: false
				});
			}, function (error) {
				console.error(error);
				// if (onPreloadError) {
				// 	onPreloadError(error)
				// }
				if (onPreloadStateChange) {
					onPreloadStateChange(false);
				}
				_this2.setState({
					isPreloading: false
				});
			});
		}
	}, {
		key: 'scrollIntoView',
		value: function scrollIntoView() {
			var _this3 = this;

			var _props2 = this.props,
			    shouldScrollIntoView = _props2.scrollIntoView,
			    scrollIntoViewDelay = _props2.scrollIntoViewDelay,
			    expandAnimationDuration = _props2.expandAnimationDuration;

			if (!shouldScrollIntoView) {
				return Promise.resolve();
			}
			return new Promise(function (resolve) {
				_this3.scrollIntoViewTimer = (0, _requestAnimationFrameTimeout.setTimeout)(function () {
					// https://github.com/stipsan/scroll-into-view-if-needed/issues/359
					// scrollIntoView(this.container, false, { duration: 300 })
					(0, _scrollIntoViewIfNeeded2.default)(_this3.container, {
						scrollMode: 'if-needed',
						behavior: 'smooth',
						block: 'nearest',
						inline: 'nearest'
					});
					resolve();
				}, Math.max(scrollIntoViewDelay, expandAnimationDuration) * 1.1);
			});
		}

		// This function is called from outside in `<ExpandableList/>`.

	}, {
		key: 'render',
		value: function render() {
			var _props3 = this.props,
			    animation = _props3.animation,
			    alignment = _props3.alignment,
			    upward = _props3.upward,
			    onFocusOut = _props3.onFocusOut,
			    getTogglerNode = _props3.getTogglerNode,
			    closeLabel = _props3.closeLabel,
			    CloseButtonIcon = _props3.closeButtonIcon,
			    role = _props3.role,
			    style = _props3.style,
			    className = _props3.className,
			    children = _props3.children;
			var _state = this.state,
			    shouldRender = _state.shouldRender,
			    expanded = _state.expanded;


			if (!shouldRender) {
				return null;
			}

			// `tabIndex={ -1 }` makes the `<div/>` focusable.
			// So that `<Expandable/>` doesn't collapse on click inside it (top, bottom).

			// `aria-hidden={true/false}` is not set automatically here
			// because when `<Expandable/>` is collapsed then it's not rendered.

			// tabIndex={ -1 }

			var element = _react2.default.createElement(
				'div',
				{
					ref: this.storeContainerNode,
					onKeyDown: this.onKeyDown,
					role: role,
					'aria-hidden': this.props['aria-hidden'],
					'aria-label': this.props['aria-label'],
					style: style,
					className: (0, _classnames2.default)(className, 'rrui__shadow', 'rrui__expandable', 'rrui__expandable--overlay', animation && 'rrui__expandable--' + animation, animation && expanded && 'rrui__expandable--expanded--' + animation, {
						'rrui__expandable--expanded': expanded,
						'rrui__expandable--left-aligned': alignment === 'left',
						'rrui__expandable--right-aligned': alignment === 'right',
						'rrui__expandable--upward': upward,
						'rrui__expandable--downward': !upward
					}) },
				_react2.default.Children.map(children, function (child) {
					return _react2.default.cloneElement(child, {
						className: (0, _classnames2.default)(child.props.className, 'rrui__expandable__content', animation && 'rrui__expandable__content--' + animation, {
							'rrui__expandable__content--expanded': expanded
						})
					});
				}),
				expanded && CloseButtonIcon && _react2.default.createElement(
					_Close2.default,
					{
						onClick: this.collapse,
						closeLabel: closeLabel,
						className: (0, _classnames2.default)('rrui__close--bottom-right', 'rrui__expandable__close') },
					_react2.default.createElement(CloseButtonIcon, null)
				)
			);

			if (onFocusOut) {
				// `<OnFocusOutOrTapOutside/>` sets `onBlur` on the `<div/>`.
				// `<Expandable/>` calls `.listenToTouches()` / `.stopListeningToTouches()` manually.
				element = _react2.default.createElement(
					_OnFocusOutOrTapOutside2.default,
					{
						ref: this.onFocusOutRef,
						getContainerNode: this.getContainerNode,
						getTogglerNode: getTogglerNode,
						onFocusOut: this.onFocusOut,
						listenToTouches: false },
					element
				);
			}

			return element;
		}
	}]);

	return Expandable;
}(PureComponent), _class.propTypes = {
	// The default animation could be called "expand".
	animation: _propTypes2.default.oneOf(['fade-up']),

	// Can optionally preload `<Expandable/>` contents before expanding it.
	// Must return a `Promise`.
	preload: _propTypes2.default.func,
	onPreloadStateChange: _propTypes2.default.func,
	onPreloadError: _propTypes2.default.func,

	onExpand: _propTypes2.default.func,
	onCollapse: _propTypes2.default.func,

	// Whether the `<Expandable/>` expands upwards or downwards.
	alignment: _propTypes2.default.oneOf(['left', 'right']),

	// If this flag is set to `true`,
	// then the dropdown expands itself upward.
	// (as opposed to the default downward)
	upward: _propTypes2.default.bool,

	// ARIA `role` (accessibility).
	role: _propTypes2.default.string,

	// CSS style object.
	style: _propTypes2.default.object,

	// CSS class.
	className: _propTypes2.default.string,

	// When the `<Expandable/>` is expanded
	// its content may not fit on the screen.
	// If `scrollIntoView` is `true` (which is the default)
	// then the browser will automatically scroll
	// so that the expanded content fits on the screen.
	scrollIntoView: _propTypes2.default.bool.isRequired,

	// If `scrollIntoView` is `true` (which is the default)
	// then these two are gonna define the delay after which it scrolls into view.
	expandAnimationDuration: _propTypes2.default.number.isRequired,

	scrollIntoViewDelay: _propTypes2.default.number.isRequired,

	getTogglerNode: _propTypes2.default.func,
	onFocusOut: _propTypes2.default.func,

	// `aria-label` for the "Close" button
	// (which is an "x" visible in fullscreen mode).
	closeLabel: _propTypes2.default.string,

	// The "x" button icon that closes the `<Select/>`
	// in fullscreen mode on mobile devices.
	closeButtonIcon: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.oneOf([false])]).isRequired
}, _class.defaultProps = {
	scrollIntoView: true,
	expandAnimationDuration: 150,
	scrollIntoViewDelay: 0,

	// The "x" button icon that closes the `<Select/>`
	// in fullscreen mode on mobile devices.
	closeButtonIcon: _Close.CloseIcon
}, _temp2);
exports.default = Expandable;
//# sourceMappingURL=Expandable.js.map